export default {
    AddSuggestionPillAction: {
        datapoint: {
            name: 'AddSuggestionPillAction',
            customData: function (kind) { return [kind]; },
        },
    },
    RemoveSuggestionPillAction: {
        datapoint: {
            name: 'RemoveSuggestionPillAction',
            customData: function (kind) { return [kind]; },
        },
    },
    SuggestionTextAutocompleted: {
        datapoint: {
            name: 'Search_SuggestionTextAutocompleted',
            customData: function (source) { return [source]; },
        },
    },
};
//# sourceMappingURL=datapoints.js.map